<template>
    <nav id="menu-container">
        <sub-menu
            v-for="(menuItem, index) of menu"
            :key="index"
            :menu-item="menuItem"
        />
    </nav>
</template>
<script setup lang="ts">
    import ArrowRight from "@icons/arrow-black-right.svg";
    import { Link } from "@inertiajs/vue3";
    import { type Link as LikeType } from "@interfaces/Link";
    import SubMenu from "@/components/Menu/SubMenu.vue";
    import { type PropType } from "vue";
    let menu = defineModel({
        type: Array as PropType<LinkType[]>,
        default() {
            return [];
        }
    });
</script>
